jQuery(document).ready(function ($) {
    "use strict";

    $('a.menu-link').on('click', function (e) {
        e.preventDefault();
        var did = $(this).data('link');
        $('body').toggleClass('is-active');
        $('div' + did).toggleClass('is-active');
    });

    $('.menu-item-has-children').on('click', function () {
        $(this).toggleClass('sub-menu__show-menu');
        $(this).find('.sub-menu').toggleClass('sub-menu__visible');
    });

    $('a.main-header__close-link').on('click', function (e) {
        e.preventDefault();
        var did = $(this).data('link');
        $('body').toggleClass('is-active');
        $('div' + did).toggleClass('is-active');
    });

    // $(window).scroll(function () {
    //     if ($(window).scrollTop() > 145) {
    //         $('.main-header').addClass('main-header__scrolled');
    //         $('body').addClass('scrolled');
    //     } else {
    //         $('.main-header').removeClass('main-header__scrolled');
    //         $('body').removeClass('scrolled');
    //     }
    // });

    // Initial check of the viewport width

    if ( $(window).width() > 850) {
        $('.main-menu-nav').removeClass('grid__cell--four-eighths').addClass('grid__cell--six-eighths');
        $('.hamburger-icon').css('display', 'none');
    } else {
        $('.main-menu-nav').removeClass('grid__cell--six-eighths').addClass('grid__cell--four-eighths');
        $('.hamburger-icon').css('display', 'block');
    }

    // Checking if the viewport is being resized

    $(window).resize(function() {

        if ( $(window).width() > 850) {
            $('.main-menu-nav').removeClass('grid__cell--four-eighths').addClass('grid__cell--six-eighths');
            $('.hamburger-icon').css('display', 'none');
        } else {
            $('.main-menu-nav').removeClass('grid__cell--six-eighths').addClass('grid__cell--four-eighths');
            $('.hamburger-icon').css('display', 'block');
        }

    });

});
